import debounce from "lodash/debounce";
import { FC, KeyboardEventHandler, RefObject } from "react";
import { SearchIcon } from "../../SearchIcon/SearchIcon";

interface Props {
  inputRef?: RefObject<HTMLInputElement>;
  onKeyDown?: KeyboardEventHandler<HTMLInputElement>;
  onChange?: (value: string) => void;
}

export const SearchBox: FC<Props> = ({ inputRef, onKeyDown, onChange }) => {
  const onInput = debounce(() => {
    onChange?.(inputRef?.current?.value ?? "");
  }, 250);

  return (
    <div className="flex h-[64px] items-center gap-[10px] border-b border-[#ccc] px-[16px]">
      <SearchIcon fill="#999999" />
      <input
        ref={inputRef}
        type="text"
        className="h-full flex-1 text-[18px] outline-none"
        placeholder="記事を検索"
        onKeyDown={onKeyDown}
        onChange={onInput}
      />
    </div>
  );
};
